import { render } from "./AppTextLabel.vue?vue&type=template&id=17656e89&scoped=true"
import script from "./AppTextLabel.vue?vue&type=script&lang=js"
export * from "./AppTextLabel.vue?vue&type=script&lang=js"

import "./AppTextLabel.vue?vue&type=style&index=0&id=17656e89&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17656e89"]])

export default __exports__